import { render, staticRenderFns } from "./vFormLOGIN.vue?vue&type=template&id=53d64b1e&"
import script from "./vFormLOGIN.vue?vue&type=script&lang=js&"
export * from "./vFormLOGIN.vue?vue&type=script&lang=js&"
import style0 from "./vFormLOGIN.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports